
import {
    Box, TextField, FormControl, InputAdornment, InputLabel, Input, IconButton, Button,
    Typography, Select, MenuItem, FormHelperText, Alert, Paper, Backdrop, Divider, Chip
} from '@mui/material';
import { AccountCircleOutlined, Visibility, VisibilityOff, LockOutlined, Group } from '@mui/icons-material';
import { useState, useEffect } from 'react';
import { useSelector, useDispatch, } from 'react-redux';
import { set, groupBy, range } from 'lodash';
import { Tabs } from '../../components/tabs';
import { Grid } from '../../components/table';
import { CONFIG } from '../../../config'
import axios from 'axios';
import { ToolBar } from '../../components/toolbar';
import { Modal } from '../../components/modal';
import { FormA } from '../../components/form';
import moment from 'moment';
import { getFormState } from '../../../helpers/form';
import dayjs from 'dayjs';
import CircularProgress from '@mui/material/CircularProgress';
import { SelectA } from '../../components/form';
import CallIcon from '@mui/icons-material/Call';
import Avatar from '@mui/material/Avatar';
import avtarImg from '../../../assets/images/avatar1.jpg'
import CircleIcon from '@mui/icons-material/Circle';
import FiberManualRecordIcon from '@mui/icons-material/FiberManualRecord';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import Shift from './shift';
import BufferAllocation from './buffer-allocation';
var isBetween = require('dayjs/plugin/isBetween')

dayjs.extend(isBetween)

const { Manager } = require("socket.io-client");

const API_HOST = CONFIG.modules['accounts'].host
const API_HOST_CRM = CONFIG.modules['crm'].host



const aGrid = { width: '50%', display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', border: '.5px solid grey' }
const text1 = { fontSize: '.8em' }
const text2 = { fontSize: '.8em', fontWeight: 'bold' }



export const LiveAllocation = ({ viewType }) => {
    let socket
    let socket2
    const { roles, user, users, Designations, Departments, Languages, Districts, Shifts, map } = useSelector((state) => (state.user || {}))
    const [view, setView] = useState('Agent')
    const [states, setStates] = useState({})
    const [analyticsMap, setAnalyticsMap] = useState({})
    const [shiftsByUsers, setShiftByUsers] = useState({})
    const [shiftAnalyticsMap, setShiftAnalyticsMap] = useState({})
    const [dataByShifts, setDataByshifts] = useState({})
    const [userShiftMap, setUserShiftMap] = useState({})
    const [filter, setFilter] = useState({
        date: dayjs()
    })

    useEffect(() => {
        console.log('SS', Shifts)
    }, [Shifts])

    const getShiftsByUsers = () => {
        axios.get(API_HOST + `/todays-shifts-by-users?forDate=${dayjs().format('YYYY-MM-DD')}`).then((resp) => {
            if (resp.data && resp.data.success) {
                setShiftByUsers(resp.data.data)
            }
        }).catch((e) => {
            console.log(e)
        })
    }
    const getAllShiftAnalytics = () => {
        axios.get(API_HOST_CRM + '/shift-analytics').then((resp) => {
            if (resp.data && resp.data.success) {
                setShiftAnalyticsMap(resp.data.data.reduce((a, e) => {
                    a[e.shift] = e;
                    return a
                }, {}))
            }
        }).catch((e) => {
            console.log(e)
        })
    }
    useEffect(() => {
        getAnalyticsUserWise()
    }, [])
    useEffect(() => {
        console.log(dataByShifts)
    }, [dataByShifts])
    const getCapacity = () => {
        axios.get(API_HOST_CRM + '/get-capacities-by-shifts').then((resp) => {
            if (resp.data && resp.data.success) {
                setDataByshifts(Object.values(resp.data.sData || {}).reduce((a, e) => {
                    a[e.shift.shift] = e
                    return a;
                }, {}))
            }
        }).catch((e) => {
            console.log(e)
        })
    }

    useEffect(() => {
        if (view === 'Shift') {
            // getAllShiftAnalytics()
            getCapacity()

        }
        // getSchedulesByUsers()
    }, [view])



    const renderData = (da) => {
        const { data } = da
        return (<>
            <Box sx={{ display: 'flex' }}>
                <Box sx={aGrid}>
                    <Typography sx={text1}>Total Agents </Typography>

                    <Typography sx={text2}>{data?.totalAgents}</Typography>
                </Box>
                <Box sx={aGrid}>
                    <Typography sx={text1}>Available </Typography>
                    <Typography sx={text2}>{data?.available}</Typography>
                </Box>
                <Box sx={aGrid}>
                    <Typography sx={text1}>Absent  </Typography>
                    <Typography sx={text2}>{data?.absent}</Typography>
                    {/* <div className='pb-1 text-center'>
                        <BufferAllocation />
                    </div> */}
                </Box>
            </Box>
            <Box sx={{ display: 'flex' }}>
                <Box sx={aGrid}>
                    <Typography sx={text1}>Total Capacity </Typography>

                    <Typography sx={text2}>{data?.capacity}</Typography>
                </Box>
                <Box sx={aGrid}>                                                            <Typography sx={text1}>Alloted</Typography>
                    <Typography sx={text2}>{data?.assigned}</Typography>
                </Box>
                <Box sx={aGrid}>
                    <Typography sx={text1}>Overload  </Typography>
                    <Typography sx={text2}>{(data?.capacity || 0) - (data?.assigned || 0)}</Typography>
                    {/* <div className='pb-1 text-center'>
                        <BufferAllocation />
                    </div> */}
                </Box>
            </Box>
            <Box sx={{ display: 'flex' }}>
                <Box sx={aGrid}>                                                            <Typography sx={text1}>Buffer Capacity</Typography>
                    <Typography sx={text2}>{data.buffer}</Typography>
                </Box>
                <Box sx={aGrid}>                                                            <Typography sx={text1}>Buffer Allotted</Typography>
                    <Typography sx={text2}>{data?.assignedOnBuffer}</Typography>
                </Box>
                <Box sx={aGrid}>
                    <Typography sx={text1}>Buffer Unallotted</Typography>
                    <Typography sx={text2}>{data.buffer > data?.assignedOnBuffer ? data.buffer - data?.assignedOnBuffer : 0}</Typography>



                </Box>
            </Box></>)
    }

    useEffect(() => {
        if (user && viewType == 'today') {

            const manager2 = new Manager(CONFIG.modules['crm'].socket, {
                reconnectionDelayMax: 10000,
                path: "/crm"
            });
            socket2 = manager2.socket("/common", {
                query: {
                    token: localStorage.getItem('authToken') || ''
                }
            });
            // console.log('mm', user._id)

            socket2.on(`shift-analytics`, (data) => {
                const { sData } = data
                setDataByshifts(Object.values(sData || {}).reduce((a, e) => {
                    a[e.shift.shift] = e
                    return a;
                }, {}))

            })
            const manager = new Manager(CONFIG.modules['accounts'].socket, {
                reconnectionDelayMax: 10000,
                path: "/accounts"
            });
            socket = manager.socket("/common", {
                query: {
                    token: localStorage.getItem('authToken') || ''
                }
            });

            socket.on(`agent-state-change`, (data) => {
                // console.log(data)
                const { user, state } = data

                setStates(newData => {
                    console.log(!!newData[user._id], user.name, state)
                    if (newData[user._id]) {
                        newData[user._id].state = state
                    }
                    return { ...newData }
                })
            })
            socket.on(`agent-analytics`, (d) => {
                const { user, data } = d
                setAnalyticsMap(previous => {
                    if (previous[user]) {
                        previous[user] = data
                    }
                    return { ...previous }
                })

            })
        }
    }, [user])

    const getStates = () => {
        axios.get(API_HOST + '/get-agent-state').then((resp) => {
            if (resp.data && resp.data.success) {
                setStates(resp.data.data.reduce((a, e) => {
                    a[e.user._id] = e
                    return a
                }, {}))
            }
        }).catch((e) => {
            console.log(e)
        })
    }
    useEffect(() => {
        getShiftsByUsers()
        getStates()
        return () => {
            if (socket) {
                socket.removeAllListeners();
            }
            if (socket2) {
                socket2.removeAllListeners();
            }
        }
    }, [])
    const getAnalyticsUserWise = async () => {
        const datas = []
        const requests = []
        for (const s of Object.values(states)) {
            requests.push(new Promise((done) => {
                axios.get(API_HOST_CRM + '/agent-analytics/' + s.user._id + `?forDate=${viewType == "today" ? dayjs().format("YYYY-MM-DD") : dayjs(filter.date).format("YYYY-MM-DD")}`).then((resp) => {
                    if (resp.data && resp.data.success) {
                        datas.push({ ...resp.data.data, id: s.user._id })
                    }
                    done(1)
                }).catch((e) => {
                    console.log(e)
                    done(1)
                })
            }))
        }
        await Promise.all(requests)
        setAnalyticsMap(datas.reduce((a, e) => {
            a[e.id] = e
            return a
        }, {}))

    }
    useEffect(() => {
        // console.log('analytics', analyticsMap)
    }, [analyticsMap])
    useEffect(() => {
        // console.log('states', states)
        if (states && view == "Agent") {
            getAnalyticsUserWise()

        }
    }, [states])


    return (
        <>

            <Box sx={{ width: '100%' }}>
                <ToolBar
                    filters={[
                        {
                            field:
                            {
                                type: 'select',
                                label: 'View by',
                                option: { key: 'options', value: '_id', label: 'name' },
                                name: 'viewBy'
                            }
                            , data: {
                                options: [
                                    { _id: 'Agent', name: 'Agent' },
                                    { _id: 'Shift', name: 'Shift' },
                                ]
                            }, onChange: (name, value, multiple) => {
                                setView(value)
                            },
                            state: {
                                viewBy: view
                            }
                        },
                        ...(viewType == "past" ? [{
                            field: {
                                name: 'date',
                                type: 'date',
                                label: 'Date',
                            },
                            onChange: (name, value) => {
                                filter[name] = value
                                setFilter({ ...filter })
                            },
                            state: filter

                        }] : [])

                    ]} />

                {/* <Box sx={{ display: 'flex', width: '15%', mt: 3 }}>
                    <SelectA field={
                        {
                            type: 'select',
                            label: 'View by',
                            option: { key: 'options', value: '_id', label: 'name' },
                            name: 'viewBy'
                        }
                    } data={{
                        options: [
                            { _id: 'Agent', name: 'Agent' },
                            { _id: 'Shift', name: 'Shift' },
                        ]
                    }} onChange={(name, value, multiple) => {
                        setView(value)
                    }} value={view} />
                </Box> */}


                <Box>

                </Box>

                {/* <div className='col-12'>
                    <Shift states={states} shiftsByUsers={shiftsByUsers} analyticsMap={analyticsMap} />
                </div> */}


                <Box sx={{ width: '100%' }}>
                    <Box sx={{ display: 'flex', flexWrap: 'wrap' }}>
                        {
                            view == 'Agent' && states &&
                            <div className='col-12'>
                                <Shift states={states} shiftsByUsers={shiftsByUsers} analyticsMap={analyticsMap} map={map} />
                            </div>
                        }

                    </Box>
                </Box>
                {
                    view == 'Shift' &&
                    <>
                        <Box >
                            <Typography><AccessTimeIcon />On Going</Typography>
                            <Divider />
                        </Box>
                        {/* <Box sx={{ width: 1500, overflow: 'scroll', mb: 3 }}> */}
                        <Box sx={{ width: '1500', mb: 3 }}>
                            <Box sx={{ display: 'flex', flexWrap: 'wrap' }}>
                                {
                                    Shifts.filter(s => {
                                        // console.log(s._id)
                                        const current = {
                                            h: new Date().getHours(),
                                            m: new Date().getMinutes(),
                                        }
                                        const cT = (current.h * 60) + current.m
                                        const start = {
                                            h: new Date(s.start).getHours(),
                                            m: new Date(s.start).getMinutes(),
                                        }
                                        const sT = (start.h * 60) + start.m
                                        const end = {
                                            h: new Date(s.end).getHours(),
                                            m: new Date(s.end).getMinutes(),
                                        }
                                        const eT = (end.h * 60) + end.m
                                        return cT >= sT && cT <= eT
                                    }).map((shift, i) => {

                                        return (
                                            <Box sx={{ border: '.5px solid grey', borderRight: '.5px solid grey', borderRadius: 3, mt: 1, ml: 1 }}>
                                                <Box sx={{ padding: 2 }}>
                                                    <Box sx={{ display: 'flex', width: 400, justifyContent: 'space-between', alignItems: 'center' }}>
                                                        <Box sx={{ display: 'flex', alignItems: 'center' }}>
                                                            <Typography variant='p' sx={{ fontWeight: 'bold', fontSize: '.8em' }}>{shift.name}</Typography>
                                                            &nbsp; <Chip label={` (${dayjs(shift.start).format('hh:mm:A')}-${dayjs(shift.end).format('hh:mm:A')})`} color="primary" />

                                                        </Box>
                                                        <Box>
                                                            &nbsp; <Chip icon={<CallIcon />} label={`OnGoing`} color="success" size="small" variant="outlined" />


                                                        </Box>
                                                    </Box>
                                                </Box>
                                                <Divider />
                                                <Box sx={{ padding: 2 }}>
                                                    <Box sx={{ display: 'flex', flexDirection: 'column', width: '90%', flexWrap: 'wrap' }}>
                                                        {
                                                            dataByShifts[shift._id] &&//true &&//shiftAnalyticsMap[shift._id] &&
                                                            <>
                                                                {renderData(dataByShifts[shift._id])}

                                                            </>
                                                        }
                                                        {
                                                            !dataByShifts[shift._id] &&
                                                            <Typography>No Agents Alloted</Typography>
                                                        }

                                                    </Box>
                                                </Box>

                                            </Box>
                                        )
                                    })
                                }
                            </Box>
                        </Box>

                        <Box >
                            <Typography><AccessTimeIcon />Up coming</Typography>
                            <Divider />
                        </Box>
                        {/* <Box sx={{ width: 1500, overflow: 'scroll', mb: 3 }}> */}
                        <Box sx={{ width: 1500, mb: 3 }}>
                            <Box sx={{ display: 'flex', flexWrap: 'wrap' }}>
                                {

                                    Shifts.filter(s => {
                                        const current = {
                                            h: new Date().getHours(),
                                            m: new Date().getMinutes(),
                                        }
                                        const cT = (current.h * 60) + current.m
                                        const start = {
                                            h: new Date(s.start).getHours(),
                                            m: new Date(s.start).getMinutes(),
                                        }
                                        const sT = (start.h * 60) + start.m
                                        const end = {
                                            h: new Date(s.end).getHours(),
                                            m: new Date(s.end).getMinutes(),
                                        }
                                        const eT = (end.h * 60) + end.m
                                        // console.log(cT, sT, eT, s.name)
                                        return cT < sT
                                    }).map((shift, i) => {

                                        return (
                                            <Box sx={{ border: '.5px solid grey', borderRight: '.5px solid grey', borderRadius: 3, mt: 1, ml: 1 }}>
                                                <Box sx={{ padding: 2 }}>
                                                    <Box sx={{ display: 'flex', width: 400, justifyContent: 'space-between', alignItems: 'center' }}>
                                                        <Box sx={{ display: 'flex', alignItems: 'center' }}>
                                                            <Typography variant='p' sx={{ fontWeight: 'bold', fontSize: '.8em' }}>{shift.name}</Typography>
                                                            &nbsp; <Chip label={` (${dayjs(shift.start).format('hh:mm:A')}-${dayjs(shift.end).format('hh:mm:A')})`} color="primary" />

                                                        </Box>
                                                        <Box>
                                                            &nbsp; <Chip icon={<CallIcon />} label={`Up coming`} color="success" size="small" variant="outlined" />


                                                        </Box>
                                                    </Box>
                                                </Box>
                                                <Divider />
                                                <Box sx={{ padding: 2 }}>
                                                    <Box sx={{ display: 'flex', flexDirection: 'column', width: '90%', flexWrap: 'wrap' }}>
                                                        {
                                                            dataByShifts[shift._id] &&
                                                            <>
                                                                <>
                                                                    {renderData(dataByShifts[shift._id])}

                                                                </>
                                                            </>
                                                        }
                                                        {
                                                            !dataByShifts[shift._id] &&
                                                            <Typography>No Agents Alloted</Typography>
                                                        }

                                                    </Box>
                                                </Box>

                                            </Box>
                                        )
                                    })
                                }
                            </Box>
                        </Box>

                        <Box >
                            <Typography><AccessTimeIcon />Completed</Typography>
                            <Divider />
                        </Box>
                        {/* <Box sx={{ width: '100%', overflow: 'scroll', mb: 3 }}> */}
                        <Box sx={{ width: '100%', mb: 3 }}>
                            <Box sx={{ display: 'flex', flexWrap: 'wrap' }}>
                                {

                                    Shifts.filter(s => {
                                        const current = {
                                            h: new Date().getHours(),
                                            m: new Date().getMinutes(),
                                        }
                                        const cT = (current.h * 60) + current.m
                                        const start = {
                                            h: new Date(s.start).getHours(),
                                            m: new Date(s.start).getMinutes(),
                                        }
                                        const sT = (start.h * 60) + start.m
                                        const end = {
                                            h: new Date(s.end).getHours(),
                                            m: new Date(s.end).getMinutes(),
                                        }
                                        const eT = (end.h * 60) + end.m
                                        return cT > eT
                                    }).map((shift, i) => {

                                        return (
                                            <Box sx={{ border: '.5px solid grey', borderRight: '.5px solid grey', borderRadius: 3, mt: 1, ml: 1 }}>
                                                <Box sx={{ padding: 2 }}>
                                                    <Box sx={{ display: 'flex', width: 400, justifyContent: 'space-between', alignItems: 'center' }}>
                                                        <Box sx={{ display: 'flex', alignItems: 'center' }}>
                                                            <Typography variant='p' sx={{ fontWeight: 'bold', fontSize: '.8em' }}>{shift.name}</Typography>
                                                            &nbsp; <Chip label={` (${dayjs(shift.start).format('hh:mm:A')}-${dayjs(shift.end).format('hh:mm:A')})`} color="primary" />

                                                        </Box>
                                                        <Box>
                                                            &nbsp; <Chip icon={<CallIcon />} label={`Completed`} color="success" size="small" variant="outlined" />


                                                        </Box>
                                                    </Box>
                                                </Box>
                                                <Divider />
                                                <Box sx={{ padding: 2 }}>
                                                    <Box sx={{ display: 'flex', flexDirection: 'column', width: '90%', flexWrap: 'wrap' }}>
                                                        {
                                                            dataByShifts[shift._id] &&
                                                            <>

                                                                {renderData(dataByShifts[shift._id])}

                                                            </>

                                                        }
                                                        {
                                                            !dataByShifts[shift._id] &&
                                                            <Typography>No Agents Alloted</Typography>
                                                        }
                                                    </Box>
                                                </Box>

                                            </Box>
                                        )
                                    })
                                }
                            </Box>
                        </Box>
                    </>
                }




            </Box>

        </>
    )
}